export default __webpack_public_path__ + "static/media/blobT.c37cf14f.png";